import {
    ActivationPeriodsForCrfStorageInterface, CaseMetaData, CoreConfiguration, CRFServiceInterface,
    CRFVersionSelectionStrategy, CurrentContextService, Helpers, NamedBindings, UserServiceInterface
} from '@dandelion/core';
import { inject, injectable } from 'inversify';


@injectable()
export class CRFVersionSelectionStrategyForProsafe extends CRFVersionSelectionStrategy {
    constructor(
        @inject(NamedBindings.CoreConfiguration) protected coreConfiguration: CoreConfiguration,
        @inject(NamedBindings.CRFService) protected crfService: CRFServiceInterface,
        @inject(NamedBindings.CurrentContextService) protected currentContextService: CurrentContextService,
        @inject(NamedBindings.ActivationPeriodForCentreCodeStorage)
        protected activationPeriodsForCrfStorage: ActivationPeriodsForCrfStorageInterface,
        @inject(NamedBindings.UserService) protected userService: UserServiceInterface) {
        super(coreConfiguration, crfService, currentContextService, activationPeriodsForCrfStorage, userService);
    }

    protected getReferenceDate(_variableName: string, model: any, _caseMetaData: CaseMetaData): Date {
        const caseConfiguration = this.currentContextService.getCaseConfiguration();
        let referenceDateVariableName = caseConfiguration.referenceDateVariableName;
        if (!model.consentNotNecessary && model.consent === 'no') {
            referenceDateVariableName = 'icuAdmDate';
        }
        return this.checkReferenceDate(new Date(Helpers.getObjByPath(referenceDateVariableName, model)));
    }
}